import React from 'react';
import classNames from 'classnames';

import ResizedImage from 'rebook/apps/utils/components/ResizedImage';

import styles from './style.scss';


class BookCoverImage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpened: false,
      isLoaded: false,
    };
  }

  componentDidMount() {
    // close book cover popup on esc button
    document.onkeydown = (e) => {
      if (e.keyCode == 27 && this.state.isOpened) {
        this.closeBookCover();
      }
    };
  }

  openBookCover() {
    document.querySelector('body').classList.add('isNotScrollable');

    this.setState({
      isOpened: true,
    });
  };

  closeBookCover() {
    document.querySelector('body').classList.remove('isNotScrollable');

    this.setState({
      isOpened: false,
    });
  }

  render() {
    const { isOpened } = this.state;
    const { book, width, height } = this.props;
    const isAudioBook = book.type==='audio';
    const coverWidth = width ? width : 256;
    const coverHeight = height ? height : 426;
    return (
      <React.Fragment>
        <div onClick={() => this.openBookCover()} className={styles.coverImageWrapper}>
          <ResizedImage
            width={coverWidth}
            height={isAudioBook ? 256 : coverHeight}
            className={classNames(styles.coverImage, `${isAudioBook ? styles.coverImageAudio : styles.coverImageText}`)}
            src={book.default_cover}
            alt={book.name} />
          {isAudioBook && (<i className={styles.audioBookIcon} />)}
        </div>
        {isOpened && (
          <React.Fragment>
            <div className="transparentOverlay" onClick={() => this.closeBookCover()} />
            <div className={styles.coverImageContainer} onClick={() => this.closeBookCover()}>
              <ResizedImage
                className={styles.coverImageFullSize}
                width={600}
                src={book.default_cover}
                alt={book.name}
                noWidth
                disableLazyLoad
                showPreloader />
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  };
}

export default BookCoverImage;
